import axios from 'axios';

const API_KEY = '$2a$16$jnPa1Yl0rslEH1kkmT4a1.7UgfPp6S0HHVQx7H.Ohy7q3L1jZJQz.';

const instance = axios.create({
  // baseURL: 'http://localhost:5236/api',
  // baseURL: 'http://192.168.100.86:5236/api',
  baseURL: 'https://api-validacao-documentos.uzerpass.com.br/api',
  // baseURL: 'https://carteirinha-api.uzerpass.com.br/api',
  headers: {
    apiKey: API_KEY,
  },
});

export default instance;
